<template>
    <div class="flex flex-col items-center gap-4 md:gap-8 w-full max-w-4xl">
        <!-- Header -->
        <div class="text-center leading-tight">
            <div class="max-w-2xl display-medium text-balance mb-2 md:mb-6">
                <span class="gradient-text">How would you like to get started?</span>
            </div>
            <p class="text-valence-grey-750 text-center text-pretty body md:display-serif max-w-2xl">
                Choose the path that works best for you. You can always change your mind later.
            </p>
        </div>

        <!-- Three Path Cards -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 w-full max-w-4xl">
            <OnboardingPathCard
                :is-selected="selectedPath === 'guided'"
                icon="bi-card-list"
                title="Guided Onboarding"
                description="Spend a few minutes sharing your role, challenges, and goals to get personalized insights instantly."
                duration="2-4 minutes"
                label="Recommended"
                data-testid="path-guided"
                @select="selectPath('guided')" />

            <OnboardingPathCard
                :is-selected="selectedPath === 'chat'"
                icon="bi-stars"
                title="Chat with Nadia"
                description="Jump straight into a conversation. Ask questions, share thoughts, or get advice on a challenge."
                duration="Start immediately"
                label="Flexible"
                @select="selectPath('chat')" />

            <OnboardingPathCard
                :is-selected="selectedPath === 'homepage'"
                icon="bi-house-fill"
                title="Go to the homepage"
                description="Explore on your own. Check out features, browse resources, and start when you're ready."
                duration="Self guided"
                label="No commitment"
                @select="selectPath('homepage')" />
        </div>
    </div>
</template>

<script setup>
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted, ref } from "vue";

import OnboardingPathCard from "./OnboardingPathCard.vue";

const emit = defineEmits(["pathSelected"]);

const selectedPath = ref(null);

function selectPath(path) {
    selectedPath.value = path;
    emit("pathSelected", path);
}

// Log event when path selection is displayed
onMounted(() => {
    logUserInteraction("onboarding_path_displayed");
});
</script>
